import { render } from "./SettingsCustomersFeedback.vue?vue&type=template&id=7fd1b537&scoped=true&ts=true"
import script from "./SettingsCustomersFeedback.vue?vue&type=script&lang=ts"
export * from "./SettingsCustomersFeedback.vue?vue&type=script&lang=ts"

import "./SettingsCustomersFeedback.vue?vue&type=style&index=0&id=7fd1b537&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd1b537"]])

export default __exports__